import type { InstanceLoadStatus } from "./types";

const state = {
	// Модалка. Уведомления (Колокольчик)
	modalNotify: { isShow: false },

	// Модалка. Профиль
	modalProfile: { isShow: false },

	// Модалка с фильтрами для мобильных устройств
	modalMobileFilters: { isShow: false },

	// Модалка - Активировать канал
	modalActivateChannel: { isShow: false },

	// Тип устройства (desktop or mobile)
	device: { isMobile: false },

	// Список инстансов
	instances: {},

	// Подробная информация об инстансе
	instance: {},

	// До первого запроса карточки не показываем ни отказ, ни ошибку загрузки.
	instanceLoadStatus: "idle" as InstanceLoadStatus,

	// Создаем инстанс
	instanceCreateState: {},

	// Переход на другую страницу
	redirectState: {},

	// Удаляем инстанс
	instanceDeleteState: {},

	// Модалка. Получить QR код
	modalQrCodeState: { isShow: false },

	// Получить QR код
	qrCodeState: {},

	// Перезагружаем инстанс
	instanceRebootState: {},

	// Logout instance
	instanceLogoutState: {},

	// Сохраняем настройки
	instanceSetSettingsState: {},

	// Модалка. Лог действий
	modalEventLogState: { isShow: false },

	// Лог действий
	eventLogState: {},

	// Лог действий. Запись события
	sendEventLogState: {},

	// Список опций для покупок
	optionListState: [],
};

export default state;
